import type { CustomCellRendererProps } from "ag-grid-react";
import PhoneNumber from "src/containers/user/PhoneNumber";
import type { UID } from "src/types";

interface PhoneNumberCellRendererProps extends CustomCellRendererProps {
  data: { uid: UID };
}

export const PhoneNumberCellRenderer = ({
  data,
}: PhoneNumberCellRendererProps): React.ReactElement => {
  return <PhoneNumber uid={data.uid} />;
};
